import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseControlDirective } from 'app/shared/directives/control/base-control.directive';

@Component({
  selector: 'kh-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordInputComponent),
      multi: true
    }
  ],
  standalone: false
})
export class PasswordInputComponent extends BaseControlDirective<string> {
  @Input() public class = '';
  @Input() public name = '';
  @Input() public placeholder = '';
  @Input() public error = false;
  @Input() public ariaLabel = '';
  @Input() public testId = '';

  public showPassword = false;

  public toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }
}
